<template>
    <div class="page-wrapper">
    <AppHeader title="Parked Orders" />
    <div class="container-fluid">
  <div  style="background-color: var(--theme-bg-end);">
    <div class="container-fluid" style="color: #fff;">
      <div
    style="
      display: flex;
      justify-content: flex-end;
      padding: 10px 15px;
    "
  >
    <input
      type="text"
      v-model="searchOrderId"
      class="form-control"
      placeholder="Search by order id"
      style="
        width: 300px;
        border-radius: 8px;
        background: rgba(255,255,255,0.05);
        border: 1px solid rgba(255,255,255,0.1);
        color: #ffffff;
      "
    />
  </div>
      <table class="table" style="color: #fff;">
        <thead>
          <tr>
            <th
              class="col-sm-2"
              style="
                font-size: 18px;
                text-align: right;
                padding-right: 10px;
              "
            >
              Grand Amount
            </th>
            <th
              class="col-sm-2"
              style="
                font-size: 18px;
                text-align: center;
                padding-right: 10px;
              "
            >
              Numner of items
            </th>
            <th
              class="col-sm-2"
              style="
                font-size: 18px;
                text-align: center;
                padding-right: 10px;
              "
            >
              Order Date
            </th>
            <th
              class="col-sm-3"
              style="
                font-size: 18px;
                text-align: center;
                padding-right: 10px;
              "
            >
              Order Time
            </th>
            <th class="col-sm-1" style="font-size: 18px">
              {{ this.jsonData.order_no }}
            </th>
            <th class="col-sm-1" style="font-size: 18px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filteredParked.length === 0">
            <td colspan="6" style="text-align: center; font-size: 18px">
             
            </td>
          </tr>
          <tr v-for="item in filteredParked" :key="item.orderId">
            <td
              align="right"
              style="
                font-size: 18px;
                text-align: right;
                padding-right: 10px;
              "
            >
              {{ formatNumber(item.orderAmount) }}
            </td>
            <td
              style="
                font-size: 18px;
                text-align: center;
                padding-right: 10px;
              "
            >
              {{ item.numberOfItems }}
            </td>
            <td
              style="
                font-size: 18px;
                text-align: center;
                padding-right: 10px;
              "
            >
              {{ item.orderDate }}
            </td>
            <td
              style="
                font-size: 18px;
                text-align: center;
                padding-right: 10px;
              "
            >
              {{ item.orderTime }}
            </td>
            <td>
              <button
                class="btn btn-success"
                @click="showParkedOrders(item.orderId)"
              >
                {{ item.orderId }}
              </button>
            </td>
            <td>
              <button
                v-if="hasPermission(16)"
                class="btn btn-danger"
                @click="deleteOrder(item.orderId)"
              >
                Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
    </div>
</div>
 </template>

 <script>
 import { mapGetters } from "vuex";
 import axios from "axios";
 import commonServices from "@/shared/commonServices";
 import AppHeader from "@/components/AppHeader";

 
 export default {
  name: "ParkedOrders",
  mixins: [commonServices],
  computed: {
    ...mapGetters({
      userPermissions: "modules_options/userPermissions",
    }),
    filteredParked() {
      const q = (this.searchOrderId || "").toString().trim().toLowerCase();
      if (!q) return this.parked;
      return this.parked.filter((item) =>
        String(item.orderId || "")
          .toString()
          .toLowerCase()
          .includes(q)
      );
    },
  },
  components: { AppHeader },

  data() {
    return {
      language: "ar",
      jsonData: {},
      parked: [],
      searchOrderId: "",
    };
  },
  mounted() {
    this.handleLanguage();
    this.getParked();
  },
  methods: {
    async getParked() {
      try {
        let dataURL = this.apiURL + "Orders/getOrderByStatus";
        let parkedJson = {
          appId: localStorage.appId,
          status: "1",
          userId: localStorage.userId,
        };
        let response = await axios.post(dataURL, parkedJson);
        if (response.data.status === "success") {
          if (response.data.results) this.parked = response.data.results;
        }
      } catch (error) {
        console.log(error);
      }
    },
    showParkedOrders(id) {
      this.$router.push({ name: "find", params: { invoiceNumber: id } });
    },
    async deleteOrder(id) {
      try {
        let dataURL = this.apiURL + "Orders/deleteOrder";
        let orderJson = {
          appId: localStorage.appId,
          orderId: id,
          deleted_by: localStorage.userId,
        };
        let response = await axios.post(dataURL, orderJson);
        if (response.data.status === "success") {
          this.getParked();
          this.showSuccess("Done!");
        } else {
          this.showAlert("You do ot have permission for this action!");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
 };
 </script>

 <style>
 </style>
